module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAANRJREFUSEvt1TEKwjAUBuD/0UFx8xwueiDXDnkUj+Dg4AHC69DBK3gMcVJBR0/g4iCKg0QeVCuKYGgyFMwWSL5A/j+EmHkLoIewY0fMvALQD+tiTYHBJ/eHq6swxmhwXuElSbKy1m5USdO0UxTF+T0rbcUFQNszxKOIdHUPMx/UF5H5q0HGmDERDTzhpYhMS9iVe2fOuVGe5yed124FMz9g9fYAhiKyCA0rfnPOTRoDV1cRLbyYdav1QLIsa1lrrx8PxLO/Py+v3YpvJzUQjvY1xfpM76EaZ9tUsi9qAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/shou.png
// module id = n/Ly
// module chunks = 36